export const PUBLIC_ROUTE = {
    LANDING: "/",
    PAGE_404: "/404",
};
